import { render, staticRenderFns } from "./StatusTemplateComponent.vue?vue&type=template&id=0b45ce83&lang=pug"
import script from "./StatusTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./StatusTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b45ce83')) {
      api.createRecord('0b45ce83', component.options)
    } else {
      api.reload('0b45ce83', component.options)
    }
    module.hot.accept("./StatusTemplateComponent.vue?vue&type=template&id=0b45ce83&lang=pug", function () {
      api.rerender('0b45ce83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/StatusTemplateComponent.vue"
export default component.exports